import angular from 'angular';
import UIRouter from 'angular-ui-router';

import template from './index.html';
import LandingController from './LandingController';

let namespace = angular.module('olr-mainfe-landing', [
  UIRouter
]);

namespace.config(function($stateProvider) {
  $stateProvider.state('olr.mainfe.landing', {
    url: '/index',
    controller: LandingController,
    template: template
  });
});

namespace.controller('LandingController', LandingController);

export default namespace.name;
  




/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-landing/index.js
 **/